import { graphDefault, graphOverviewAxis, graphSelection } from './';
export const graphOverviewViewportBorderLines = (theme, parameters) => {
  const graphDefaultPattern = graphDefault(theme, parameters);
  const common = {
    lineThickness: graphOverviewAxis(theme, parameters).lineThickness,
    transparency: 0
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          lineColor: graphDefaultPattern.p2
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          lineColor: graphSelection(theme, parameters).lineColor
        };
      }
    default:
      {
        return {
          ...common,
          lineColor: graphDefaultPattern.p
        };
      }
  }
};
//# sourceMappingURL=graphOverviewViewportBorderLines.js.map